

import React, {useEffect, useState} from "react";
import {NavigateBefore, NavigateNext, Inbox, UTurnLeft, DoneAll, CopyAll} from "@mui/icons-material";
import {getParcel, parcelDelivered, parcelIn, parcelReturn} from "../services/service";
import {Parcletable, Spinner} from "../components";
import {toast} from "react-toastify";

const Parcelreturn = () => {

    const [data, setData] = useState(false)
    const getParcellist = async (page) => {
        const token = JSON.parse(localStorage.getItem('admin'))
        const config = {
            headers: {
                Authorization: `Bearer ${token}`
            },
            params: {
                take: 10, page: page,
            }
        }
        const response = await getParcel(config)

        if (response) {
            setData(response.data)

        }

    }
    useEffect(() => {



        getParcellist()



    }, []);


    let content
    if (data !== false) {
        if (data.items.length > 0) {
            content = <Parcletable>
                {data.items.map((item) => {
                    return (
                        <>
                            <tr key={item.id} className='has-text-centered yekan'>

                                <td>

                                    {item.parcels.tracking_code}
                                    <CopyAll onClick={async function copyToClipboard() {
                                        try {
                                            await navigator.clipboard.write(item.parcels.tracking_code);
                                            toast('کپی شد.')
                                            return true; // Success

                                        } catch (err) {
                                            console.error('Failed to copy: ', err);
                                            return false; // Failure
                                        }
                                    }}/>
                                </td>
                                <td>{item.cities.name}</td>
                                <td>{item.parcels.sender_name}</td>
                                <td>{item.parcels.sender_phone}</td>
                                <td>{item.parcels.receiver_name}</td>
                                <td>{item.parcels.receiver_phone}</td>
                                <td>{item.parcels.address}</td>
                                <td>{item.parcels.type}</td>


                            </tr>
                        </>

                    )
                })}
            </Parcletable>
        } else {
            content =
                <div className='column is-12'>
                    <p className='my-3'>
                        بسته ای برای نمایش وجود ندارد 🤷‍♀️

                    </p>
                </div>

        }


    } else {
        content = <div className='column is-12'>
            <Spinner/>
        </div>
    }


    // incoming


    const [trackingcode, setTrackingcode] = useState('')
    const handleReturn = async () => {
        const token = JSON.parse(localStorage.getItem('admin'))
        const config = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }
        const conf = window.confirm('آیا  مطمن هستید ؟')
        if (conf) {



            const formdata = new FormData()
            formdata.append("tracking_code", trackingcode)





            toast.info('در حال ارسال ...')
            const response = await parcelReturn(formdata,config)
            if (response) {

                toast.dismiss()
                if (response.data.code === 1) {

                    toast.success('با موفقیت اضافه شد.');
                    setData(false)

                    getParcellist().then();
                } else {
                    toast.warning(response.data.error)
                }
            } else {
                toast.error('اتصال خود را بررسی کنید')
            }


        }

    }


    return (
        <>
            <div className='columns is-variable is-3  p-5  is-multiline '>
                <div className='column is-12 welcome__master '>
                    <h1 className='has-text-centered pinar is-size-4 clrtwotext has-text-weight-bold'>
                        مرجوع کردن مرسوله به فرستنده


                    </h1>

                    <article className='subtitle yekan my-3 is-size-6'>
                        تغییر وضعیت مرسلوه به  مرجوعی  در این بخش صورت میگیرد.
                    </article>

                </div>


                <div className='column is-12 welcome__master mt-3 '>
                    <label className='label mt-3 yekan'>کد رهگیری را وارد کنید:</label>
                    <input className="input" type="number" placeholder="کد رهگیری مرسوله"
                           onChange={(e) => setTrackingcode(e.target.value)}/>


                    <div className='has-text-centered'>
                        <button
                            className='button clrtwo has-text-white has-text-weight-bold  pinar mt-5 mx-3 borderrad1 ' onClick={() => handleReturn()}
                        >


                            ارجاع به فرستنده

                            <UTurnLeft/>


                        </button>


                    </div>


                </div>


                <div className='column is-12 welcome__master p-5 my-4 '>
                    {
                        content
                    }

                    <div className='column is-12'>
                        {data &&
                            <div className='pinar' style={{display: 'flex', justifyContent: 'center'}}>


                                {/*before page with tick*/}
                                {
                                    data.paginator.beforePage < data.paginator.currentPage && (

                                        <button onClick={() => getParcellist(data.paginator.beforePage)}
                                                className='button'>
                                            <NavigateNext/>
                                        </button>
                                    )


                                }


                                {/*map beforePages*/}
                                {data.paginator.beforePages.length > 0 &&

                                    <>
                                        {data.paginator.beforePages.map((item, index) =>
                                            <button className='button' onClick={() => getParcellist(item)}
                                                    key={index}>
                                                {item}
                                            </button>
                                        )}
                                    </>

                                }


                                {/*active*/}

                                {
                                    data.paginator.total > 0 &&
                                    <button
                                        className='clrtwo has-text-white button'>{data.paginator.currentPage}</button>


                                }


                                {/*map nextPages*/}
                                {data.paginator.nextPages.length > 0 &&
                                    <>
                                        {data.paginator.nextPages.map((item, index) =>
                                            <button className='button' onClick={() => getParcellist(item)}
                                                    key={index}>
                                                {item}
                                            </button>
                                        )}
                                    </>

                                }


                                {/*next page with tick*/}
                                {

                                    data.paginator.nextPage > data.paginator.currentPage && (

                                        <button onClick={() => getParcellist(data.paginator.nextPage)}
                                                className='button is-transparent'>
                                            <NavigateBefore/>
                                        </button>
                                    )


                                }


                            </div>
                        }
                    </div>


                </div>


            </div>


        </>
    )
}
export default Parcelreturn